import auth from "../../middlewares/auth";

export const cloudNetworkRoutes = [
    {
        path: '/cloud-networks',
        component: () => import(/* webpackChunkName: "services" */ '../../views/services/cloud_networks/CloudNetworkIndex.vue'),
        name: 'cloud_networks',
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/create-cloud-network',
        component: () => import(/* webpackChunkName: "services" */ '../../views/services/cloud_networks/CreateCloudNetworkForm.vue'),
        name: 'create_cloud_network',
        meta: {
            middleware: [
                auth
            ]
        }
    },
]